import {
  startToolOperation,
  type ToolAnalyticsContext,
  type ToolPresetMask,
} from '@saas-pages/shared/public/runtime'
import type {
  DedupeOptions,
  DedupeResult,
} from '@/pages/udalit-dubli-strok/dedupe-lines'

const BASE_CONTEXT = {
  app: 'txtify',
  domain: 'txtify.ru',
  route: '/udalit-dubli-strok',
  utility: 'dedupe-lines',
  processingMode: 'local',
} as const

export function dedupePresetMask(options: DedupeOptions): ToolPresetMask {
  return (
    (options.ignoreCase ? 1 : 0)
    | (options.ignoreOuterSpaces ? 2 : 0)
    | (options.removeBlankLines ? 4 : 0)
  ) as ToolPresetMask
}

function context(
  options: DedupeOptions,
  result: DedupeResult,
): ToolAnalyticsContext {
  return {
    ...BASE_CONTEXT,
    presetMask: dedupePresetMask(options),
    outcome: result.changed ? 'changed' : 'unchanged',
  }
}

export function reportDedupeSuccess(
  options: DedupeOptions,
  result: DedupeResult,
  durationMs: number,
): void {
  startToolOperation(context(options, result)).success(durationMs)
}
